import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import COLORS from "../../common/Colors";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Icon from "../SideNavIcon";
import { useDispatch, useSelector } from "react-redux";
import useSystemNavigation from "../../SysHooks";
import { setIsSideBarCollapsed } from "../../Redux/systemSlice";
import { useLocation } from "react-router-dom";

const StyledAppDiv = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  color: white;
  width: 70px;
  padding: 2px;
  margin: auto;
  background-color: ${COLORS.sidebar};

  .icons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding-top: 10px;
  }
`;

const BoxIcon = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  height: 60px;
  color: #fff;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &.active {
    background-color: ${COLORS.ACTIVE_APP_BAR};
    color: #ffffff;
  }
  span {
    line-height: 1.5;
  }
`;

const SideBarToggleIcon = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  height: 60px;
  cursor: pointer;
  color: white;
`;

const AppSidebarLayout = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const menuList = useSelector((state) => state.systemTracking.menuItem);
  useEffect(() => {

  },[menuList])

  const isSideBarCollapsed = useSelector((state) => state.systemTracking.isSideBarCollapsed)
  const { goOtherMenu } = useSystemNavigation()

  const hasSubMenu = (menu) =>
    menu.subMenu.length > 0 && menu.subMenu.some((subMenu) => subMenu.access);

  const menuListWithSubmenu = menuList?.filter((menu) => {
    return hasSubMenu(menu);
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 728) {
        dispatch(setIsSideBarCollapsed(true));
      } else {
        dispatch(setIsSideBarCollapsed(false));
      }
    };

    // Initial check on mount
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);


  // const isAnyMenuActive = menuListWithSubmenu?.some((menu) => menu.active);
  // console.log("isAnyMenuActive", isAnyMenuActive)

  // const isHomeActive = !isAnyMenuActive;

  // const activePage = useLocation().pathname.replace("/", "");

  const handleToggleSideBar = () => {
    // if(activePage === "dashboard"){
    //   return dispatch(setIsSideBarCollapsed(true))
    // }
    dispatch(setIsSideBarCollapsed(!isSideBarCollapsed))
  };

  const isMenuActive = useCallback((menu) => {
    return menu.subMenu.some((subMenu) => location.pathname.includes(subMenu.path));
  }, [location.pathname]);


  const handleClickOtherMenu = (menu) => {
    if (isSideBarCollapsed) {
      dispatch(setIsSideBarCollapsed(false));
    }
    if (isMenuActive(menu)) {
      return; // Prevent unnecessary navigation
    }
    goOtherMenu(menu);
  };

  const memoizedIsMenuActive = useCallback((menu) => isMenuActive(menu), [isMenuActive]);
  const memoizedGoOtherMenu = useCallback((menu, flag) => goOtherMenu(menu, flag), [goOtherMenu]);

  useEffect(() => {
    const activeMenu = menuList.find((menu) => memoizedIsMenuActive(menu));

    if (activeMenu && !activeMenu.active) {
      memoizedGoOtherMenu(activeMenu, true);
    }
  }, [location.pathname, menuList, memoizedGoOtherMenu, memoizedIsMenuActive]);


  // const handleClickHome = () => {
  //   dispatch(setIsSideBarCollapsed(true))
  //   goHome()
  // }

  return (
    <>
      <StyledAppDiv>
        <SideBarToggleIcon onClick={handleToggleSideBar}>
          {isSideBarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          {/* <MenuOutlined /> */}
        </SideBarToggleIcon>

        <div className="icons">
          {/* <BoxIcon className={`${isHomeActive ? "active" : ""}`} onClick={handleClickHome}>
            <Icon name="home" />
            <span>Home</span>
          </BoxIcon> */}

          {menuListWithSubmenu?.map((menu, index) => (
            <BoxIcon key={index} className={isMenuActive(menu) ? "active" : ""} onClick={() => handleClickOtherMenu(menu)}>
              {menu.icon && <Icon name={menu.icon} />}
              <span>{menu.title}</span>
            </BoxIcon>
          ))}
        </div>
      </StyledAppDiv>
    </>
  );
};

export default AppSidebarLayout;
